export const SidebarData = [
  {
    title: "Manage Customers",
    path: "/dashboard/manage-customer",
    roles: ["stringer", "staff", "admin", "superadmin"],
  },
  {
    title: "View Bookings",
    path: "/dashboard/booking-customer",
    roles: ["stringer", "staff", "admin", "superadmin"],
  },
  {
    title: "BigCommerce Invoices",
    path: "/dashboard/bigcommerce-invoices",
    roles: ["superadmin"],
  },
  {
    title: "Booking Receipts",
    path: "/dashboard/booking-receipts",
    roles: ["superadmin"],
  },

  {
    title: "Invite Customer",
    path: "/dashboard/send-invite",
    roles: ["stringer", "staff", "admin", "superadmin"],
  },
  {
    title: "Credit Management",
    path: "/dashboard/free-service-management",
    roles: ["stringer", "admin", "superadmin"],
  },
   {
    title: "Your Staff",
    path: "/dashboard/admin-users",
    roles: ["superadmin", "admin"],
  },
  {
    title: "Stringing Discounts",
    path: "/dashboard/stringing-discounts",
    roles: ["superadmin"],
  },
  {
    title: "Express Settings",
    path: "/dashboard/express-settings",
    roles: ["admin", "superadmin"],
  },
  {
    title: "Active Stringing",
    path: "/dashboard/active-stringing",
    roles: ["stringer", "superadmin", "staff", "admin"],
  },
  {
    title: "Stringer Dashboard",
    path: "/dashboard/stringer-dashboard",
    roles: ["stringer", "superadmin"],
  },
  {
    title: "String Inventory",
    path: "/dashboard/stringer-inventory",
    roles: ["stringer", "superadmin", "admin"],
  },
  {
    title: "Record Service",
    path: "/dashboard/stringer-service",
    roles: ["stringer", "superadmin"],
  },
];
